<script setup>
import { Switch } from "@/shared/ui/switch";

defineProps({
  icon: { type: String, default: null },
  title: { type: String, required: true },
  sub: { type: String, default: "" },
  modelValue: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);
</script>

<template>
  <div
    :class="[
      'flex items-center gap-3 px-3.5 py-3 border bg-card transition-colors',
      modelValue
        ? 'bg-[hsl(0_0%_97%)] border-input'
        : 'border-border hover:bg-muted hover:border-input',
      disabled ? '' : 'cursor-pointer',
    ]"
    style="border-radius: var(--radius)"
    @click="
      (e) =>
        !disabled &&
        !e.target.closest('[role=switch]') &&
        emit('update:modelValue', !modelValue)
    "
  >
    <div
      :class="[
        'w-8 h-8 flex items-center justify-center shrink-0',
        modelValue
          ? 'bg-card text-foreground'
          : 'bg-muted text-muted-foreground',
      ]"
      style="border-radius: var(--radius)"
    >
      <SvgIcon
        v-if="icon"
        :name="icon"
        style="width: 16px; height: 16px; fill: none"
      />
    </div>
    <div class="flex-1 min-w-0">
      <div class="text-[13px] font-medium text-foreground">{{ title }}</div>
      <div v-if="sub" class="text-[12px] text-muted-foreground">
        {{ sub }}
      </div>
    </div>
    <Switch
      :model-value="modelValue"
      :disabled="disabled"
      @update:model-value="emit('update:modelValue', $event)"
    />
  </div>
</template>
